const MAX_BYTES = 10 * 1024 * 1024;

export async function compressPdf(file: File): Promise<File> {
  if (file.size <= MAX_BYTES) {
    return file;
  }

  const module = await import(
    /* webpackIgnore: true */ "https://cdn.jsdelivr.net/npm/@jspawn/ghostscript-wasm@0.0.2/gs.mjs" as string
  ).catch(() => null);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const initGhostscript = (module as any)?.default;

  const gs = await initGhostscript({
    locateFile: (f: string) =>
      `https://cdn.jsdelivr.net/npm/@jspawn/ghostscript-wasm@0.0.2/${f}`,
  });

  const buffer = await file.arrayBuffer();
  gs.FS.writeFile("input.pdf", new Uint8Array(buffer));

  await gs.callMain([
    "-sDEVICE=pdfwrite",
    "-dCompatibilityLevel=1.4",
    "-dPDFSETTINGS=/printer",
    "-dNOPAUSE",
    "-dQUIET",
    "-dBATCH",
    "-sOutputFile=output.pdf",
    "input.pdf",
  ]);

  const compressed: Uint8Array = gs.FS.readFile("output.pdf");
  const arrayBuffer = compressed.buffer.slice(
    compressed.byteOffset,
    compressed.byteOffset + compressed.byteLength,
  ) as ArrayBuffer;

  return new File([arrayBuffer], file.name, { type: "application/pdf" });
}
